import { Result } from 'antd';
import { Button } from '@bettercomp/ui-components';

interface Props {
  onRetry: () => void;
  label?: string;
}

export function RetryableError({ onRetry, label = 'Try again' }: Props) {
  return (
    <Result
      data-testid="auth-retryable-error"
      status="warning"
      title="We couldn't complete sign-in"
      subTitle="Something went wrong reaching the sign-in service. You can try again."
      extra={
        <Button type="primary" onClick={onRetry}>
          {label}
        </Button>
      }
    />
  );
}
